var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.tab.rental")) + " ")]), _c('v-card-text', [_c('rental-sheet', {
    attrs: {
      "rental": _vm.value,
      "showCost": false,
      "showAttachment": false,
      "hideCompanyDetails": true
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }